import { useQuery } from '@tanstack/react-query';
import { getAppDownloadConfig } from '@/lib/app-download/app-download.api';

export const appDownloadQueryKeys = {
  config: (projectKey: string) => ['app-download', projectKey] as const,
} as const;

export function useAppDownloadConfig(projectKey = 'zangia') {
  return useQuery({
    queryKey: appDownloadQueryKeys.config(projectKey),
    queryFn: () => getAppDownloadConfig(projectKey),
    staleTime: 5 * 60 * 1000,
    gcTime: 30 * 60 * 1000,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    retry: false,
  });
}
